import { LocalizerHelper } from "../../helpers/localizerHelper";

interface Props {
  quid?: string;
}

const StickyFooterQuid: React.FC<Props> = ({ quid }) => {
  if(!quid) return null;
  return (
    <div className="sticky-footer row">
        <p className='col-12'>{LocalizerHelper.localized('generic_actions')}</p>
        <div className="btn btn-continue-web col-5 center">
            <a target="_blank" href={`https://app.chuzeat.com?quid=${quid}`}>
                {LocalizerHelper.localized('continue_web')}
            </a>
        </div>
        <div className="btn btn-download-app col-6 center">
            <a target="_blank" href={`https://chuze.at/t/${quid}?redirectToStore=true`}>
                <img  src="/assets/icon_download.svg" alt="download"/>
                {LocalizerHelper.localized('download_app')}
            </a>
        </div>
    </div>
  );
};

export default StickyFooterQuid;
